import React, { useState, useEffect, useCallback } from "react";
import api from "../../services/api";
import useAuth from "../../hooks/useAuth";
import { Link } from "react-router-dom";
import { Modal, Button } from "react-bootstrap";
import Autocomplete from "../HtmlElements/Autocomplete";
import ConfirmDialog from "../HtmlElements/ConfirmDialog";
import "./Accounts.css";
import ScreenLoader from "../HtmlElements/ScreenLoader";
import Alert from "../HtmlElements/Alert";
import { useUser } from "../../context/UserContext";
import AsyncSelect from "react-select/async";
import ActionDropdown from "../HtmlElements/ActionDropdown";
import SubmitActionButton from "../HtmlElements/SubmitActionButton";
import ActionCheckbox from "../HtmlElements/ActionCheckbox";
import { useDispatch } from "react-redux";
import { resetAllAccDepen } from "../../store/features/actions/commonActions";
import AccountPlanTdComp from "./AccountPlanTdComp";
import { getDemoRequestsToMapAccount } from "../../services/accIqService";
import iq_api_v2 from "../../services/iqApiV2";
import * as FeatherIcon from "react-feather";
import qs from "qs";
import StatusIndicator from "../Frontend/genericComponents/resizeableTable/StatusIndicator";
import { useConfig } from "../../context/AppConfigContext";
import {
  formatValueInBillions,
  numberWithCommas,
} from "../../services/commonService";

import Select from "react-select";
import GenerateKSOpportunities from "./GenerateKSOpportunities";
import ReviewAccount from "./ReviewAccount";

const Accounts = () => {
  useAuth(); // Ensure the user is authenticated

  const { appConfig } = useConfig();

  // const showBanner = useBanner();

  const { user } = useUser();
  const current_role_key = user?.role_key;

  const [successMessage, setSuccessMessage] = useState("");
  const [accounts, setAccounts] = useState([]);
  const [error, setError] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage] = useState(10);
  const [sortField, setSortField] = useState("client_name");
  const [sortOrder, setSortOrder] = useState("asc");
  const [filter, setFilter] = useState({
    client_name: "",
    account_name: "",
    is_deleted: 0,
    is_active: "",
  });
  const [showAddAccModal, setShowModal] = useState(false);

  const [newClientName, setNewClientName] = useState("");
  const [newClientCode, setNewClientCode] = useState("");
  // const [newAccountName, setNewAccountName] = useState("");
  // const [newAccountCode, setNewAccountCode] = useState("");

  const [showConfirm, setShowConfirm] = useState(false);
  const [companyToDelete, setCompanyToDelete] = useState(null);
  const [companyToMapDemoRequest, setCompanyToMapDemoRequest] = useState('');

  const [addApiError, setApiError] = useState("");
  const [loader, setLoader] = useState(false);
  const [totalPages, setTotalPages] = useState(1);
  const [showArchive, setShowArchive] = useState(0);
  // const [showDemo, setShowDemo] = useState(0);
  const [formData, setFormData] = useState({});

  // const [inputValue, setValue] = useState("");
  // const [selectedValue, setSelectedValue] = useState(null);
  const [action, setAction] = useState({ action: "" });
  const [checkedItems, setCheckedItems] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [updateDataStatus, setupdateDataStatus] = useState(false);
  const [demoRequests, setDemoRequests] = useState([]);
  const [selectedDemoRequest, setSelectedDemoRequest] = useState("");
  const [enteredTicker, setEnteredTicker] = useState("");
  const [customError, setCustomError] = useState({});
  const [activeDownloadId, setActiveDownloadId] = useState(null);
  const [companies, setCompanies] = useState([]);
  const [totalNumberOfRecords, setTotalNumberOfRecords] = useState("");
  const [lastAccountsRefreshUserLog, setLastAccountsRefreshUserLog] = useState({});

  const [demoRequestID, setDemoRequestID] = useState([])
  const [selectedDemoRequestData, setSelectedDemoRequestData] = useState("")
  const [dataUpdateQue, setDataUpdateQue] = useState([])
  const [selectedDemoRequestIDErr, setSelectedDemoRequestIDErr] = useState("")

  // const { registerTask, getTaskData } = useTaskStatus();
  

  useEffect(() => {
    if(demoRequests.length){
      let demo_requests_temp = (demoRequests || []).map(request => ({
        id: request._id,
        name: request.name,
        lead_id: request.lead_id,
        buyer_account_name: request.buyer_account_name,
        seller_account_name: request.seller_account_name,
        sales_person_name_and_designation: request.sales_person_name_and_designation,
        icp_name_and_designation: request.icp_name_and_designation,
    }));
      setDemoRequestID(demo_requests_temp)
    }
  }, [demoRequests])

  const get_latest_accounts_refresh_user_log = async () => {
    const response = await api.get("/accounts/get_latest_accounts_refresh_user_log", {});

    // console.log("responseresponseresponse : ", response)
    const user_info = response.data.result.list[0];
    setLastAccountsRefreshUserLog(user_info)
  }


  // const handleReviewAccount = async(client_name, account_name) =>{
  //   setLoader(true);
  //   try {
  //     //const postData = qs.stringify({"client": client_name, "account": account_name});
  //     const postData = {"client": client_name, "account": account_name};
  //     const response = await iq_api_v2.post(`/review_account`, '', {
  //       'params': postData
  //     });
  //     console.log("response : ", response)
  //     setSuccessMessage("Account reviewed successfully..!");
  //     setTimeout(() => {
  //       setSuccessMessage("");
  //     }, 5000)
  //   } catch (error) {
  //     console.error("Error refreshing accounts:", error);
  //   }
  //   // await get_latest_accounts_refresh_user_log();
  //   // setupdateDataStatus(true)
  //   setLoader(false);
  // }

  const handleRefreshAccountsData = async() =>{
    setLoader(true);
    try {
      await api.post(`/accounts/generate_account_details`, {});
      setSuccessMessage("Accounts refreshed successfully..!");
      setTimeout(() => {
        setSuccessMessage("");
      }, 5000)
    } catch (error) {
      console.error("Error refreshing accounts:", error);
    }
    await get_latest_accounts_refresh_user_log();
    setupdateDataStatus(true)
    setLoader(false);
  }

  const handleAutoCompleteChange = (e) => {
    const { name, value, code } = e.target;
    if (name === "client_name") {
      setNewClientName(value);
      setNewClientCode(code);
      setCustomError((prevErrors) => ({
        ...prevErrors,
        newClientName: "",
      }));
    } else if (name === "account_name") {
      // setNewAccountName(value);
      // setNewAccountCode(code);
    }
  };

  useEffect(() => {
    const fetchDemoRequestList = async () => {
      const demo_requests = await getDemoRequestsToMapAccount();
      setDemoRequests(demo_requests);
    };
    fetchDemoRequestList();
  }, []);

  useEffect(() => {
    // Fetch company list from the API
    const fetchCompanies = async () => {
      setLoader(true);
      try {
        const filterData = {
          is_active: 1,
          is_deleted: 0,
          limit: 1000,
          sort_by: "company_name",
        };
        const response = await api.get("/companies/get_companies", {
          params: filterData,
        });
        const companies = [...response.data.result.list];

        setCompanies(companies); // Assuming the response contains an array of companies
      } catch (error) {
        console.error("Error fetching companies:", error);
      }
      setLoader(false);
    };

    get_latest_accounts_refresh_user_log()
    fetchCompanies();
    
  }, []);

  const fetchAccounts = useCallback(async () => {
    setLoader(true);

    // Dummy Call for sync specific account
    // const response = await api.post('/accounts/re_add_accounts', {});
    // return false

    try {
      if (filter.is_active === "") {
        delete filter.is_active;
      }
      if (filter.status === "") {
        delete filter.status;
      }
      const response = await api.get("/accounts/get_accounts", {
        params: {
          page: currentPage,
          limit: perPage,
          sort_by: sortField,
          order: sortOrder,
          ...filter,
        },
      });
      // console.log(response.data.result.list);
      setAccounts(response.data.result.list);
      setTotalPages(Math.ceil(response.data.result.total / perPage));
      setTotalNumberOfRecords(Math.ceil(response.data.result.total));
    } catch (err) {
      setError(err.message || "Failed to fetch Accounts");
    }
    setLoader(false);
  }, [currentPage, perPage, sortField, sortOrder, filter, updateDataStatus, dataUpdateQue]);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(resetAllAccDepen());
    let successMessage = sessionStorage.getItem("successMessage");
    if (successMessage) {
      setSuccessMessage(successMessage);
      sessionStorage.removeItem("successMessage"); // Clear the message
    }
    fetchAccounts();
  }, [fetchAccounts]);

  useEffect(() => {
    if (checkedItems.length > 0 && checkedItems.length === accounts.length) {
      setSelectAll(true);
    } else {
      setSelectAll(false);
    }
  }, [checkedItems]);

  // useEffect(() => {
  //   accounts.map((account) => {
  //     const TASK_ID = `generate_ks_opportunities_${account.client_name}_${account.account_name}`;
  //     const taskData = getTaskData(TASK_ID)||{};
  //     console.log("taskData : ", taskData)
  //   })
  // }, [accounts])

  /*const getselectedAMObjects = (AMIds) => {
    return accounts.filter(amuser => AMIds.includes(amuser.id));
  };

  const selectedAMObjects = getselectedAMObjects(formData.accountmanager);*/

  const handleSort = (field) => {
    const order = sortField === field && sortOrder === "asc" ? "desc" : "asc";
    setSortField(field);
    setSortOrder(order);
  };

  /*const handleFilterChange = (e) => {
    setCurrentPage(1);
    setFilter({ ...filter, [e.target.name]: e.target.value });
  };*/
  const showArchived = (e) => {
    setCurrentPage(1);
    //alert(e.target.value);
    //let temp = document.getElementById("archived");*/
    let temp = e.target;
    if (temp.value === 0) {
      //temp.value = 1;
      e.target.value = 1;
      setFilter({ ...filter, [e.target.name]: e.target.value });
    } else {
      //temp.value = 0;
      e.target.value = 0;
      setFilter({ ...filter, [e.target.name]: e.target.value });
    }
    setShowArchive(temp.value);
  };

  const showForDemo = (e) => {
    setCurrentPage(1);
    //alert(e.target.value);
    //let temp = document.getElementById("archived");*/
    let temp = e.target;
    if (temp.value === 0) {
      //temp.value = 1;
      e.target.value = 1;
      setFilter({ ...filter, [e.target.name]: e.target.value });
    } else {
      //temp.value = 0;
      e.target.value = "";
      setFilter({ ...filter, [e.target.name]: e.target.value });
    }
    // setShowDemo(temp.value);
  };

  const handleFilterChange = (e) => {
    setCurrentPage(1);
    setFilter({ ...filter, [e.target.name]: e.target.value });
  };

  // const handleActionChange = (e) => {
  //   setAction({ ...action, [e.target.name]: e.target.value });
  // };

  // const modalAddAccount = () => {
  //   setShowModal(true);
  // };

  const handleAddAccount = async (e) => {
    e.preventDefault();

    const newError = {};
    let isValid = true;

    if (!formData?.accounts?.length) {
      newError.accounts = "Account required.";
      isValid = false;
    }

    if (newClientName === "") {
      newError.newClientName = "Client name required";
      isValid = false;
    }

    if (enteredTicker === "") {
      newError.enteredTicker = "Account ticker required.";
      isValid = false;
    }

    if (selectedDemoRequest === "") {
      newError.newDemoRequest = "Demo request required.";
      isValid = false;
    }

    setCustomError(newError);
    if (!isValid) return;

    const formattedData = {
      newaccountstoadd: formData.accounts,
    };
    console.log(formattedData);

    return false;

    setLoader(true);
    try {
      const response = await api.post("/accounts/add_account", {
        /*account_name: newAccountName,
        account_code: newAccountCode,*/
        accounts: formData.accounts,
        client_name: newClientName?.trim(),
        client_code: newClientCode?.trim(),
        demo_request_id: selectedDemoRequest,
        ticker: enteredTicker,
      });

      if (response.data.status === 201 || response.data.status === 200) {
        setSuccessMessage("Account added successfully");
        setTimeout(() => {
          setSuccessMessage("");
        }, 2000);

        fetchAccounts();
        handleClose();
      } else {
        setApiError(
          response.data.result.message ||
            "An error occurred while saving the company."
        );
      }
    } catch (err) {
      setError(err.message || "Failed to add account");
    }
    setLoader(false);
  };

  const showRequestMap = (companyId, demo_request_id) => {

    const selected_data = demoRequestID.find(item => item.id === demo_request_id)
    setSelectedDemoRequestData(selected_data)
    setCompanyToMapDemoRequest(companyId);
  };

  const hideRequestMap = () => {
    setCompanyToMapDemoRequest('');
    setSelectedDemoRequestData('')
    setSelectedDemoRequestIDErr('')
  };

  const handleDemoRequestIdChange = (selected_data) => {
    setSelectedDemoRequestData(selected_data)
  }

  const handleMapSubmit = async () => {

    if(!selectedDemoRequestData?.id){
      setSelectedDemoRequestIDErr("Select Demo Request ID")
      return false;
    }

    setLoader(true);
    try {
      await api.post(`/accounts/update_account_demo_request_map`, {'account_id': companyToMapDemoRequest, demo_request_id: selectedDemoRequestData.id });
      hideRequestMap();
      setSuccessMessage("Account mapped successfully..!");

      const temp = dataUpdateQue;
      setDataUpdateQue(temp.push(true))

     setTimeout(() => {
      setSuccessMessage("");
     }, 5000)

    } catch (error) {
      console.error("Error deleting company:", error);
    }
    setLoader(false);
  };

  const handleClose = () => {
    setShowModal(false);
    setNewClientName("");
    setNewClientCode("");
    // setNewAccountName("");
    // setNewAccountCode("");
  };

  const handleDelete = async () => {
    setLoader(true);
    try {
      await api.delete(`/accounts/delete_account/${companyToDelete}`);
      hideDeleteConfirm();
      setSuccessMessage("Account deleted successfully..!");
      setAccounts((prevCompanies) =>
        prevCompanies.filter((company) => company.id !== companyToDelete)
      );
    } catch (error) {
      console.error("Error deleting company:", error);
    }
    setLoader(false);
  };

  const showDeleteConfirm = (companyId) => {
    setCompanyToDelete(companyId);
    setShowConfirm(true);
  };

  const hideDeleteConfirm = () => {
    setShowConfirm(false);
    setCompanyToDelete(null);
  };
  const handleFirstPage = () => {
    setCurrentPage(1);
    setSelectAll(false);
    setCheckedItems([]);
  };

  const handleLastPage = () => {
    setCurrentPage(totalPages);
    setSelectAll(false);
    setCheckedItems([]);
  };

  const handlePrevPage = () => {
    if (currentPage > 1) setCurrentPage(currentPage - 1);
    setSelectAll(false);
    setCheckedItems([]);
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) setCurrentPage(currentPage + 1);
    setSelectAll(false);
    setCheckedItems([]);
  };

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
    setSelectAll(false);
    setCheckedItems([]);
  };

  const getPageNumbers = () => {
    const pageNumbers = [];
    const startPage = Math.max(1, currentPage - 2);
    const endPage = Math.min(totalPages, currentPage + 2);
    for (let i = startPage; i <= endPage; i++) {
      pageNumbers.push(i);
    }
    return pageNumbers;
  };

  if (current_role_key === undefined || !appConfig) {
    return <></>;
  }
  if (current_role_key === "CLIENT") {
    // navigate('/user_profile/profile');
    window.location.replace("/user_profile/profile");
  }

  const companyDomains = appConfig.company_domains;

  const handleInputChange = (value) => {
    // setValue(value);
    setCustomError((prevErrors) => ({
      ...prevErrors,
      accounts: "",
    }));
  };

  const handleChange = (value) => {
    // setSelectedValue(value);
    const newAccountslist = value.map((newaccountsObj) => {
      return {
        account_name: newaccountsObj.name,
        account_code: newaccountsObj.ciq_id,
      };
    });

    setFormData({
      ...formData,
      accounts: newAccountslist,
    });
    // console.log("SELECTED VALUES: "+JSON.stringify(formData))
  };

  const handleTickerChange = (e) => {
    setEnteredTicker(e.target.value);
    setCustomError((prevErrors) => ({
      ...prevErrors,
      ticker: "",
    }));
  };

  const handleDemoRequestChange = (e) => {
    setSelectedDemoRequest(e.target.value);
    setCustomError((prevErrors) => ({
      ...prevErrors,
      newDemoRequest: "",
    }));
  };

  const getAccounts = (text) => {
    return iq_api_v2
      .post("/company/search_company/?search_string=" + text)
      .then((result) => {
        const res = result.data;
        return res;
      });
  };

  const downloadFile = async (id, client_name, account_name, title = "") => {
    try {
      setActiveDownloadId(id);
      const docType = "text/csv";

      const formData = qs.stringify({
        client: client_name,
        account: account_name,
      });

      const response = await iq_api_v2.post(
        `analytics/download_analytics_stats`,
        formData,
        {
          responseType: "blob",
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            Accept: "application/json", // Matches your curl
          },
        }
      );
      const newBlob = new Blob([response.data], { type: docType });
      const url = window.URL.createObjectURL(newBlob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `${account_name} ${title} document`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      setActiveDownloadId(null);
    } catch (error) {
      console.error("Error downloading the file", error);
      setActiveDownloadId(null);
    } finally {
      setActiveDownloadId(null);
    }
  };

  return (
    <div className="account_wrapper">
      {loader === true && <ScreenLoader />}
      <div className="container-fluid mt-3 p-4">
        {successMessage && <Alert type="success" message={successMessage} />}
        {error && <Alert type="danger" message={error} />}

        <div className="row">
          <div className="col-md-9">
            <h4 className="blue add_user_heading">Accounts List</h4>
          </div>
          {/* <div className="col-md-3 align-right pb-3">
              <Link className="add_account_btn" to="#" onClick={modalAddAccount}>
              <i className="fa fa-plus" aria-hidden="true"></i> Add Account
              </Link>
            </div> */}
        </div>

        <div className="row mb-3 mt-4">
          <div className="col-md-9">
            <div className="left_filter">
              <div className="admin_filter_head">
                <h5 className="">Filter</h5>
              </div>
              <div className="row">
                <div className="col">
                  {/* <input
              type="text"
              className="form-control custom_form_control"
              placeholder="Filter by Client Name"
              autoComplete="Off"
              name="client_name"
              value={filter.client_name}
              onChange={handleFilterChange}/> */}

                  <select
                    className="custom_form_control w-100"
                    as="select"
                    id="selectStatusFilter"
                    name="client_name"
                    value={filter.client_name}
                    onChange={handleFilterChange}
                  >
                    <option key="" value="">
                      Select Client Company
                    </option>
                    {companies.map((company) => (
                      <option
                        key={`sel-company-${company.id}`}
                        value={company.company_name}
                      >
                        {company.company_name}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="col">
                  <input
                    type="text"
                    className="form-control custom_form_control"
                    placeholder="Filter by Account Name"
                    autoComplete="Off"
                    name="account_name"
                    value={filter.account_name}
                    onChange={handleFilterChange}
                  />
                </div>
                <div className="col search_filter_user">
                  <select
                    className="custom_form_control w-100 form-control"
                    as="select"
                    id="selectfilter"
                    name="is_active"
                    value={filter.is_active}
                    onChange={handleFilterChange}
                  >
                    <option key="" value="">
                      Select Filter
                    </option>
                    <option key="0" value="0">
                      Inactive
                    </option>
                    <option key="1" value="1">
                      Active
                    </option>
                  </select>
                </div>

                <div className="col search_filter_user ">
                  <select
                    className="custom_form_control w-100"
                    as="select"
                    id="selectStatusFilter"
                    name="status"
                    value={filter.status}
                    onChange={handleFilterChange}
                  >
                    <option key="" value="">
                      Select Filter
                    </option>
                    <option key="0" value="0">
                      Pending
                    </option>
                    <option key="1" value="1">
                      Completed
                    </option>
                  </select>
                </div>

                <div className="col search_filter_user ">
                  <select
                    className="custom_form_control w-100"
                    as="select"
                    id="selectStatusFilter"
                    name="version"
                    value={filter.status}
                    onChange={handleFilterChange}
                  >
                    <option key="" value="">
                      Select Version
                    </option>
                    <option key="v1" value="v1">
                      V1
                    </option>
                    <option key="v2" value="v2">
                      V2
                    </option>
                  </select>
                </div>
              </div>

              <div className="row">
                <div className="col-md-6">
                  <div className="row">
                    <div className="col mt-2 search_filter_user ">
                      <select
                        className="custom_form_control w-100"
                        as="select"
                        id="selectStatusFilter"
                        name="client_industry"
                        value={filter.client_industry}
                        onChange={handleFilterChange}
                      >
                        <option key="" value="">
                          Select Client Industry
                        </option>
                        {Object.keys(companyDomains).map((key) => (
                          <option key={key} value={key}>
                            {companyDomains[key]}
                          </option>
                        ))}
                      </select>
                    </div>

                    <div
                      className="col d-flex mt-2 show_archived d-block"
                      style={{ marginTop: "-8px" }}
                    >
                      <div className="arch mr-2">
                        <input
                          id="archived"
                          type="checkbox"
                          className="form-check-input custom_input_type"
                          name="is_deleted"
                          value={filter.is_deleted}
                          onClick={showArchived}
                        />{" "}
                        <label
                          className="form-check-label custom_lable_type"
                          htmlFor="archived"
                        >
                          Archived
                        </label>
                      </div>

                      <div className="arch">
                        <input
                          id="for_demo"
                          type="checkbox"
                          className="form-check-input custom_input_type"
                          name="is_avail_for_demo"
                          value={filter.is_avail_for_demo}
                          onClick={showForDemo}
                        />{" "}
                        <label
                          className="form-check-label custom_lable_type"
                          htmlFor="for_demo"
                        >
                          For Demo
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-3">
            <div className="right_action">
              <div className="admin_filter_head">
                <h5 className="">Actions</h5>
              </div>

              <div className="row">
                <ActionDropdown
                  page="accounts"
                  action={action.action}
                  setAction={setAction}
                />
                <SubmitActionButton
                  page="accounts"
                  checkedItems={checkedItems}
                  setCheckedItems={setCheckedItems}
                  action={action.action}
                  currentPage={currentPage}
                  setSelectAll={setSelectAll}
                  setupdateDataStatus={setupdateDataStatus}
                  setSuccessMessage={setSuccessMessage}
                  setCurrentPage={setCurrentPage}
                  setLoader={setLoader}
                  setAction={setAction}
                />
              </div>
            </div>
            <Button
              style={{ textAlign: "right !important" }}
              variant="primary"
              className=" btn btn-sm w-100 mt-2 btn-outline font14"
              onClick={(e) => {
                handleRefreshAccountsData()
              }}
            >
              <FeatherIcon.RefreshCw
                style={{
                  marginTop: "-3px",
                  fontSize: "12px !important",
                  height: "17px",
                }}
              />{" "}
              Refresh Accounts Data
            </Button>
          </div>
        </div>

        <div className="row">
          <div className="col-md-6">
            <strong>Total Records:</strong>{" "}
            {totalNumberOfRecords ? totalNumberOfRecords : "0"}
          </div>
          {lastAccountsRefreshUserLog?.firstname && <div className="col-md-6 align-right font12 green">
            <span><b>Last Refreshed By:</b></span>{" "} {lastAccountsRefreshUserLog.firstname + " "+lastAccountsRefreshUserLog.lastname} ({new Date(lastAccountsRefreshUserLog.created_date + " UTC").toLocaleString("en-IN", {
                  weekday: "short",
                  year: "numeric",
                  month: "short",
                  day: "numeric",
                  hour: "2-digit",
                  minute: "2-digit",
                  timeZone: "Asia/Kolkata" 
                })
              })
          </div>
          }
          

          {/* <div className='col-md-6 mb-2'>
            <Button
                  style={{'textAlign': 'right !important', }}
                  variant="primary"
                  className="pull-right btn btn-outline font14"
                  onClick={(e) => {
                  //  downloadFile(account.id, account?.client_name, account?.account_name, 'Account Prompt Stats');
                  }}
                >
                  <FeatherIcon.RefreshCw style={{
                    marginTop: '-3px',
                    fontSize: '12px !important',
                    height: '17px'
                  }} /> Refresh Accounts Data
              </Button>
          </div> */}
        </div>

        <div className="account_list  table-responsive">
          <table className="table table-striped font14 table-bordered ">
            <thead>
              <tr className="cursor_p">
                <th>
                  {/* <input
                  type="checkbox"
                  checked={selectAll}
                  onChange={handleSelectAll}
                /> */}
                  <ActionCheckbox
                    page="accounts"
                    accounts={accounts}
                    checkedItems={checkedItems}
                    setCheckedItems={setCheckedItems}
                    selectAll={selectAll}
                    setSelectAll={setSelectAll}
                  />
                </th>
                <th
                  onClick={() => handleSort("client_name")}
                  style={{ minWidth: '150px',  whiteSpace: "nowrap" }}
                >
                  Client Name{" "}
                  {sortField === "client_name" &&
                    (sortOrder === "asc" ? "▲" : "▼")}
                </th>
                <th
                  onClick={() => handleSort("account_name")}
                  style={{ minWidth: '200px',  whiteSpace: "nowrap" }}
                >
                  Account Name{" "}
                  {sortField === "account_name" &&
                    (sortOrder === "asc" ? "▲" : "▼")}
                </th>
                <th
                  onClick={() =>
                    handleSort(
                      "processed_data.accountwise_company_info.company_type"
                    )
                  }
                  style={{ whiteSpace: "nowrap" }}
                >
                  Public / Private{" "}
                  {sortField ===
                    "processed_data.accountwise_company_info.company_type" &&
                    (sortOrder === "asc" ? "▲" : "▼")}
                </th>
                <th
                  onClick={() => handleSort("is_v1")}
                  style={{ whiteSpace: "nowrap" }}
                >
                  Version{" "}
                  {sortField === "is_v1" && (sortOrder === "asc" ? "▲" : "▼")}
                </th>
                <th
                  onClick={() => handleSort("client_industry")}
                  style={{ minWidth: '230px',  whiteSpace: "nowrap" }}
                >
                  Client Industry{" "}
                  {sortField === "client_industry" &&
                    (sortOrder === "asc" ? "▲" : "▼")}
                </th>
                <th
                  onClick={() =>
                    handleSort(
                      "processed_data.accountwise_company_info.trbc_industry_name"
                    )
                  }
                  style={{ minWidth: '230px',  whiteSpace: "nowrap" }}
                >
                  Account Industry{" "}
                  {sortField ===
                    "processed_data.accountwise_company_info.trbc_industry_name" &&
                    (sortOrder === "asc" ? "▲" : "▼")}
                </th>
                <th
                  onClick={() =>
                    handleSort(
                      "processed_data.accountwise_company_info.revenue"
                    )
                  }
                  style={{ whiteSpace: "nowrap" }}
                >
                  Revenue (Bn){" "}
                  {sortField ===
                    "processed_data.accountwise_company_info.revenue" &&
                    (sortOrder === "asc" ? "▲" : "▼")}
                </th>

                <th
                  onClick={() =>
                    handleSort("processed_data.number_of_opportunities")
                  }
                  style={{ whiteSpace: "nowrap" }}
                >
                  # Opportunities{" "}
                  {sortField === "processed_data.number_of_opportunities" &&
                    (sortOrder === "asc" ? "▲" : "▼")}
                </th>
                <th
                  onClick={() =>
                    handleSort("processed_data.number_of_contacts")
                  }
                  style={{ whiteSpace: "nowrap" }}
                >
                  # Contacts{" "}
                  {sortField === "processed_data.number_of_contacts" &&
                    (sortOrder === "asc" ? "▲" : "▼")}
                </th>

                <th
                  onClick={() => handleSort("account_name")}
                  style={{ whiteSpace: "nowrap" }}
                >
                  Added By{" "}
                  {sortField === "account_name" &&
                    (sortOrder === "asc" ? "▲" : "▼")}
                </th>
                <th
                  onClick={() => handleSort("is_active")}
                  style={{ whiteSpace: "nowrap" }}
                >
                  Is Active{" "}
                  {sortField === "is_active" &&
                    (sortOrder === "asc" ? "▲" : "▼")}
                </th>
                {/* <th onClick={() => handleSort('status')}>
                Status {sortField === 'status' && (sortOrder === 'asc' ? '▲' : '▼')}
              </th> */}
                <th
                  onClick={() => handleSort("created_date")}
                  style={{ width: "110px", whiteSpace: "nowrap" }}
                >
                  Created On{" "}
                  {sortField === "created_date" &&
                    (sortOrder === "asc" ? "▲" : "▼")}
                </th>
                <th style={{  width: "310px", minWidth: '255px',  whiteSpace: "nowrap" }}>Map Demo Request</th>
                <th style={{ whiteSpace: "nowrap" }}>Lead ID</th>
                <th style={{ whiteSpace: "nowrap" }}>MnM Seller</th>
                <th style={{ whiteSpace: "nowrap" }}>ICP Name & Designation</th>
                {showArchive !== 1 && (
                  <th style={{ whiteSpace: "nowrap" }}>Action</th>
                )}

                <th style={{ whiteSpace: "nowrap" }}>Account Plan</th>
                <th style={{ whiteSpace: "nowrap" }}>Prompt Stats</th>
              </tr>
            </thead>
            <tbody>
              {accounts.map((account, index) => {
                return (
                  <tr key={index}>
                    <td>
                      {/* <input
                    type="checkbox"
                    checked={checkedItems.includes(account.id)}
                    onChange={() => handleCheckboxChange(account.id)}
                  /> */}
                      <ActionCheckbox
                        page="accounts"
                        checkedItems={checkedItems}
                        setCheckedItems={setCheckedItems}
                        related_id={account.id}
                      />
                    </td>
                    <td>
                      {account.client_name}

                      {account?.is_avail_for_demo === 1 && (
                        <span
                          className="demo_image_ ml-1"
                          title="Available  For Demo"
                        >
                          <i className="fa fa-laptop" aria-hidden="true"></i>
                        </span>
                      )}
                    </td>
                    <td>
                      <Link
                        to={
                          "/account_details/" +
                          account.id +
                          "/" +
                          encodeURIComponent(account.account_name) +
                          "/" +
                          encodeURIComponent(account.client_name)
                        }
                      >
                        {account.account_name}
                      </Link>
                    </td>
                    <td>
                      {
                        account?.processed_data?.accountwise_company_info
                          ?.company_type
                      }
                    </td>
                    <td>{account?.is_v1 ? "V1" : "V2"}</td>
                    <td>{account?.client_industry}</td>
                    <td>
                      {
                        account?.processed_data?.accountwise_company_info
                          ?.trbc_industry_name
                      }
                    </td>
                    <td>
                      {/* {account?.processed_data?.accountwise_company_info?.company_type?.toLowerCase()?.includes('private') ? (
                  'Not Available'
                ) : (
                  account?.processed_data?.accountwise_company_info?.revenue && (
                    <>${formatValueInBillions(account.processed_data.accountwise_company_info.revenue)}Bn</>
                  )
                )} 
                */}

                      {account?.processed_data?.accountwise_company_info
                        ?.revenue && (
                        <>
                          ${" "}
                          {numberWithCommas(
                            formatValueInBillions(
                              account?.processed_data?.accountwise_company_info
                                ?.revenue
                            )
                          )}{" "}
                        </>
                      )}
                    </td>
                    <td>{account?.processed_data?.number_of_opportunities}</td>
                    <td>{account?.processed_data?.number_of_contacts}</td>
                    <td>
                      {account.created_by_firstname}{" "}
                      {account.created_by_lastname}
                    </td>
                    <td>{account.is_active === 1 ? "Yes" : "No"}</td>
                    {/* <td>{account.status === 1 ? 'Completed' : 'Pending'}</td> */}

                    <td>{account?.created_date}</td>
                    <td style={{width: '300px'}}>
                      {/* <Select
                          style={{width: '300px'}}
                          className="custom_agentform_control font14"
                          options={demoRequestID} 
                          getOptionLabel={(option) => option.name}
                          getOptionValue={(option) => option.id}
                         // defaultValue={regionsList.find(item => item.Code === "ALL")}
                         // onChange={(selected) => handleRegionChange(selected)} 
                          placeholder="Select Demo Request ID"
                      /> */}

                        <div className="row">
                          <div className="col-md-10">
                            <div className="row">
                              <div className="col-md-12">
                                {account.demo_request_id}
                              </div>
                              {/* <div className="col-md-12">
                                Mnm Salesperson Name: {account.sales_person_name_and_designation}
                              </div>
                              <div className="col-md-12">
                                ICP Name & Designation: {account.icp_name_and_designation}
                              </div> */}
                            </div>
                          </div>
                          <div className="col-md-2">
                            <span
                              onClick={() => showRequestMap(account.id, account?.demo_request_id)}
                              title="Map Demo Request ID"
                              className="cursor_p"
                            >
                              <i className="fa fa-edit" ></i>
                            </span>
                          </div>
                        </div>
                    </td>
                    <td>{account?.lead_id}</td>
                    <td>{account?.sales_person_name_and_designation}</td>
                    <td>{account?.icp_name_and_designation}</td>

                    {showArchive !== 1 && (
                      <td style={{ whiteSpace: "nowrap" }}>
                        {/* <Link to={`/accounts/edit_user/${account.id}`} className="edit_right_margin cursor_p">
                    <span><i className="fa fa-edit blue"></i></span>
                  </Link> */}
                        <span
                          onClick={() => showDeleteConfirm(account.id)}
                          className="btn btn-danger btn-sm cursor_p  font11"
                          title="Delete Account"
                        >
                          <i className="fa fa-trash"></i> Delete
                        </span> | 

                        <GenerateKSOpportunities client_name={account?.client_name} account_name={account?.account_name} /> |

                        <ReviewAccount client_name={account?.client_name} account_name={account?.account_name} />

                        {/* <span
                          onClick={() => handleReviewAccount(account?.client_name, account?.account_name)}
                          className="ml-1 btn btn-success btn-sm cursor_p  font11"
                          title="Review Account"
                        >
                          <i className="fa fa-check"></i> Review Account
                        </span> */}
                        
                      </td>
                    )}

                    <td>
                      <AccountPlanTdComp
                        key={account?.client_code + "_" + account?.account_code}
                        clientCode={account?.client_code}
                        accountCode={account?.account_code}
                        accountName={account?.account_name}
                        clientName={account?.client_name}
                        filePath={account?.file_path}
                        refreshAPI={fetchAccounts}
                      />
                    </td>

                    <td>
                      {activeDownloadId === account.id ? (
                        <StatusIndicator text="Downloading.." />
                      ) : (
                        <Button
                          disabled={false}
                          style={{ textAlign: "left !important" }}
                          variant="secondary_new"
                          className="btn-sm btn btn-outline font12"
                          title="Download Prompt Stats"
                          onClick={(e) => {
                            downloadFile(
                              account.id,
                              account?.client_name,
                              account?.account_name,
                              "Account Prompt Stats"
                            );
                          }}
                        >
                          {/* <FeatherIcon.Download style={{
                        marginTop: '-3px',
                        fontSize: '12px !important',
                        height: '17px'
                      }} /> */}{" "}
                          Download
                        </Button>
                      )}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
        <nav>
          <ul className="pagination">
            <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
              <button onClick={handleFirstPage} className="page-link">
                First
              </button>
            </li>
            <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
              <button onClick={handlePrevPage} className="page-link">
                Prev
              </button>
            </li>
            {getPageNumbers().map((pageNumber) => (
              <li
                key={pageNumber}
                className={`page-item ${
                  pageNumber === currentPage ? "active" : ""
                }`}
              >
                <button
                  onClick={() => handlePageChange(pageNumber)}
                  className="page-link"
                >
                  {pageNumber}
                </button>
              </li>
            ))}
            <li
              className={`page-item ${
                currentPage === totalPages ? "disabled" : ""
              }`}
            >
              <button onClick={handleNextPage} className="page-link">
                Next
              </button>
            </li>
            <li
              className={`page-item ${
                currentPage === totalPages ? "disabled" : ""
              }`}
            >
              <button onClick={handleLastPage} className="page-link">
                Last
              </button>
            </li>
          </ul>
        </nav>
      </div>

      <Modal show={showAddAccModal} onHide={handleClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>Add Account</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row">
            {addApiError && (
              <div className="alert alert-danger">{addApiError}</div>
            )}
          </div>
          <div className="row mb-3">
            <div className="col-md-12">
              <label
                htmlFor="labelCompanyName"
                className="form-label custom_label"
              >
                Client Name <span className="red">*</span>
              </label>
              <Autocomplete
                name="client_name"
                key="suggest_client_name"
                value={newClientName}
                onChange={handleAutoCompleteChange}
                placeholder="Client Name"
                element_field_key="client_name"
                apiUrl="/company_profiles/suggest_client_name"
                labelKey="name"
                valueKey="code"
              />
              {customError.newClientName && (
                <p className="text-danger">{customError.newClientName}</p>
              )}
            </div>
          </div>

          <div className="row">
            <div className="col-md-12">
              <label
                htmlFor="labelAccountName"
                className="form-label custom_label"
              >
                Account Name <span className="red">*</span>
              </label>
              <AsyncSelect
                name="accounts"
                getOptionValue={(e) => e.code}
                getOptionLabel={(e) => e.name}
                loadOptions={getAccounts}
                isMulti={true}
                onInputChange={handleInputChange}
                onChange={handleChange}
                displayValue="account_name"
                placeholder="Select Accounts"
                disabled
              ></AsyncSelect>
              {customError.accounts && (
                <p className="text-danger">{customError.accounts}</p>
              )}
            </div>
          </div>

          <div className="row mt-4">
            <div className="col-md-12">
              <label htmlFor="ticker" className="form-label custom_label">
                Ticker <span className="red">*</span>
              </label>
              <input
                type="text"
                name="ticker"
                className="form-control"
                value={enteredTicker}
                onChange={(e) => handleTickerChange(e)}
                style={{ fontSize: "14px", color: "#6c757d" }}
              />
              {customError.enteredTicker && (
                <p className="text-danger">{customError.enteredTicker}</p>
              )}
            </div>
          </div>

          <div className="row mt-4">
            <div className="col-md-12">
              <label
                htmlFor="newDemoRequest"
                className="form-label custom_label"
              >
                Demo Request <span className="red">*</span>
              </label>
              <select
                name="newDemoRequest"
                className="form-control"
                value={selectedDemoRequest}
                onChange={(e) => handleDemoRequestChange(e)}
                style={{ fontSize: "14px", color: "#6c757d" }}
              >
                <option value="">Select Request</option>
                {demoRequests.map((demo) => (
                  <option key={demo?._id} value={demo?._id}>
                    {demo?.seller_account_name +
                      " - " +
                      demo?.buyer_account_name +
                      " - " +
                      demo?.name}
                  </option>
                ))}
              </select>
              {customError.newDemoRequest && (
                <p className="text-danger">{customError.newDemoRequest}</p>
              )}
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button disabled={loader} variant="secondary" onClick={handleClose}>
            Close
          </Button>
          <Button disabled={loader} variant="danger" onClick={handleAddAccount}>
            Submit
          </Button>
        </Modal.Footer>
      </Modal>

      <ConfirmDialog
        show={showConfirm}
        handleClose={hideDeleteConfirm}
        handleConfirm={handleDelete}
        title="Delete Account"
        message="All generated data associated with this account will be <br /><b>permanently deleted</b> and <b>cannot be recovered</b>. <br />Are you sure you want to delete this account?"
      />

      <Modal show={companyToMapDemoRequest ? true : false} onHide={hideRequestMap} centered>
        <Modal.Header closeButton>
          <Modal.Title>Update Demo Request Map</Modal.Title>
        </Modal.Header>
        <Modal.Body >
          <div className="row mb-4">
            <label className="col-md-4 font13 d-flex align-items-center">Select Request ID</label>
            <div className="col-md-8">
              <Select
                  style={{width: '300px'}}
                  className="custom_agentform_control font14"
                  options={demoRequestID} 
                  getOptionLabel={(option) => option.id}
                  getOptionValue={(option) => option.id}
                  defaultValue={selectedDemoRequestData?.id}
                  value={selectedDemoRequestData}
                  onChange={(selected) => handleDemoRequestIdChange(selected)} 
                  placeholder="Select Demo Request ID"
              />
              {selectedDemoRequestIDErr && <div className="red font12 mt-1">{selectedDemoRequestIDErr}</div> }
            </div>
          </div>

          {selectedDemoRequestData && <div className="row font13 update_demo_request_block">
            <div className="col-md-12">
              <div className="row mb-2">
                <div className="col-md-4">
                  <label className="popUpSubHeading">Request ID :</label>
                </div>
                <div className="col-md-8">
                  <p className="right_block">{selectedDemoRequestData?.id} 
                    {/* <FeatherIcon.Copy className='copy_icon ml-4'/> */}
                  </p>
                </div>
              </div>
              <div className="row mb-2">
                <div className="col-md-4">
                  <label className="popUpSubHeading">Lead ID:</label>
                </div>
                <div className="col-md-8"><p className="right_block">{selectedDemoRequestData?.lead_id}</p></div>
              </div>

              <div className="row mb-2">
                <div className="col-md-4">
                  <label className="popUpSubHeading">Seller account name:</label>
                </div>
                <div className="col-md-8"><p className="right_block">{selectedDemoRequestData?.seller_account_name}</p></div>
              </div>
              <div className="row mb-2">
                <div className="col-md-4">
                  <label className="popUpSubHeading">Buyer account name:</label>
                </div>
                <div className="col-md-8"><p className="right_block">{selectedDemoRequestData?.buyer_account_name}</p></div>
              </div>
              <div className="row mb-2">
                <div className="col-md-4">
                  <label className="popUpSubHeading">Salesperson name:</label>
                </div>
                <div className="col-md-8"><p className="right_block">{selectedDemoRequestData?.sales_person_name_and_designation}</p></div>
              </div>
              <div className="row mb-2">
                <div className="col-md-4">
                  <label className="popUpSubHeading">Icp name & designation:</label>
                </div>
                <div className="col-md-8"><p className="right_block">{selectedDemoRequestData?.icp_name_and_designation}</p></div>
              </div>

              <div className="row mb-2">
                <div className="col-md-4">
                  <label className="popUpSubHeading">Request raised by:</label>
                </div>
                <div className="col-md-8"><p className="right_block">{selectedDemoRequestData?.name}</p></div>
              </div>
            </div>
          </div>
          }
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={hideRequestMap}>
            Cancel
          </Button>
          <Button variant="danger" onClick={handleMapSubmit}>
            Confirm
          </Button>
        </Modal.Footer>
      </Modal>

    </div>
  );
};

export default Accounts;
